import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { PendingAssignmentsSummary } from '../../_types/policy';
import _ from 'lodash';

export const getPendingAssignmentsSummary = async (
  orgId: string,
  params: Record<string, any> = {},
  signal?: AbortSignal,
  onError?: (errors: ServerErrorResponse) => void,
) => {
  const url = `${baseApiUrl()}/activity-center/v1/organizations/${orgId}/policy/pending-assignments/summary`;

  const paramString = new URLSearchParams(
    Object.entries({
      ...params,
    })
      .filter(([_k, v]) => !_.isEmpty(v))
      .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {}),
  ).toString();

  try {
    const metrics = await fetcher({
      method: 'get',
      url: `${url}?${paramString}`,
      options: { signal },
    });
    return metrics;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    console.warn('error retrieving pending assignments summary');
    throw error;
  }
};

export default function usePendingAssignmentsSummary(
  orgId: string,
  params: Record<string, any> = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void,
) {
  return useQuery<PendingAssignmentsSummary[], Error>(
    ['pending_assignments_summary', orgId, params],
    async ({ signal }): Promise<PendingAssignmentsSummary[]> => {
      return getPendingAssignmentsSummary(orgId, params, signal, onError);
    },
    {
      ...options,
      enabled: !!orgId,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: 1000 * 60 * 15, // 15 minutes
    },
  );
}
